"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _epics = _interopRequireDefault(require("./epics"));

var _reducers = _interopRequireDefault(require("./reducers"));

var _routes = _interopRequireDefault(require("./routes"));

var route = 'email';
var _default = {
  reducer: _reducers.default,
  routes: _routes.default,
  route: route,
  rootEpic: _epics.default,
  dsn: 'https://46b679648a5347ebac594f3ea65a0ff0@exceptions.hubspot.com/198195',
  shouldModuleRender: function shouldModuleRender(_ref) {
    var gates = _ref.gates;
    return gates.includes('settings-ui-beta:content');
  }
};
exports.default = _default;
module.exports = exports.default;